import React from "react";

import { Icon } from "react-icons-kit";
import { arrowRight } from "react-icons-kit/feather/";

const MockOverlay = props => {
  return (
    <div className="widget-overlay">
      <div className="widget-overlay-inner">
      <Icon size={36} icon={arrowRight} style={{ color: '#0084ff' }}/>
      </div>
    </div>
  );
};

export default MockOverlay;
